var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntWorkplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0719 4.68966C11.7108 2.32858 7.88277 2.32858 5.52169 4.68966C3.16061 7.05074 3.16061 10.8788 5.52169 13.2399L9.06042 16.7786C9.46733 17.1855 10.1263 17.1855 10.5335 16.7783L14.0719 13.2399C16.433 10.8788 16.433 7.05074 14.0719 4.68966ZM4.63719 3.80515C7.48677 0.955573 12.1068 0.955573 14.9564 3.80515C17.806 6.65474 17.806 11.2748 14.9564 14.1244L11.4181 17.6628C10.5226 18.5582 9.07167 18.5589 8.17592 17.6631L4.63719 14.1244C1.7876 11.2748 1.7876 6.65474 4.63719 3.80515ZM9.79681 7.08846C8.76054 7.08846 7.92049 7.92851 7.92049 8.96478C7.92049 10.001 8.76054 10.8411 9.79681 10.8411C10.8331 10.8411 11.6731 10.001 11.6731 8.96478C11.6731 7.92851 10.8331 7.08846 9.79681 7.08846ZM6.6696 8.96478C6.6696 7.23767 8.0697 5.83757 9.79681 5.83757C11.5239 5.83757 12.924 7.23767 12.924 8.96478C12.924 10.6919 11.5239 12.092 9.79681 12.092C8.0697 12.092 6.6696 10.6919 6.6696 8.96478Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntWorkplace);
export default __webpack_public_path__ + "static/media/ent-workplace.a0ab3d0121a997d5d9112a8ea4a23bda.svg";
export { ForwardRef as ReactComponent };